import { Component, Input } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";

@Component({
    selector: '[controparte_entity_view]',
  templateUrl: 'controparte-entity-view.component.html',
})

export class ControparteEntityViewComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  element;
}
